import { JwtHelperService } from '@auth0/angular-jwt';
import { of } from 'rxjs';
var AuthGuardServiceStub = /** @class */ (function () {
    function AuthGuardServiceStub() {
        this.claimChecked = true;
        this.jwtHelperService = new JwtHelperService();
        this.user = {
            UserId: 1,
            userName: 'test',
            IsImpersonated: false
        };
    }
    AuthGuardServiceStub.prototype.isFeatureEnabled = function () {
        return true;
    };
    AuthGuardServiceStub.prototype.canActivate = function (route, state) {
        return of(true);
    };
    AuthGuardServiceStub.prototype.logOut = function () {
    };
    AuthGuardServiceStub.prototype.logOutToOldPortal = function () {
    };
    AuthGuardServiceStub.prototype.isNavigationAuthorized = function () {
        return of(true);
    };
    AuthGuardServiceStub.prototype.getUserInfo = function () {
        return {
            cuit: '2705256745',
            taxId: '27-05256745-1'
        };
    };
    AuthGuardServiceStub.prototype.hasPermission = function (name) {
        return true;
    };
    AuthGuardServiceStub.prototype.getClaim = function (name) {
        return false;
    };
    return AuthGuardServiceStub;
}());
export { AuthGuardServiceStub };
